module.exports = __webpack_public_path__ + "img/classic_season20_5.54e85d43.jpg";